module.exports = __webpack_public_path__ + "img/logo.3f78e330.png";